/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Shawn Lim",
  title: "Hello, I'm Shawn",
  subTitle: emoji(
    "I'm an experienced Senior Full Stack Software Engineer with Over 8+ Years of Passion and Expertise"
  ),
  contact: "emailto: slkq.dev@gmail.com",
  resumeLink:
    "https://drive.google.com/file/d/1IxHaxqrwvuVO206JuJOOoIzccGmR6d6s/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/kqrxzl",
  gmail: "slkq.dev@gmail.com",
  gitlab: "https://gitlab.com/shawnkeqin",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "Seasoned Freelancer/Contractor Specializing in Diverse Tech Stacks across the frontend, backend, instrastructure, cloud and databases",
  skills: [
    emoji(
      "⚡ Crafting UI/UX-friendly frontend interfaces for enhanced user experiences in web applications"
    ),
    emoji(
      "⚡ Extensive expertise in TDD, Scrum Agile methodology, CI/CD tooling, clean code practices, and thorough code reviews"
    ),
    emoji(
      "⚡ Enhancing frontend performance through advanced techniques such as caching, server-side pagination, lazy loading, and more"
    ),
    emoji(
      "⚡ Developing robust backend services and APIs"
    ),
    emoji("⚡ Architecting highly scalable and resilient distributed systems"),
    emoji(
      "⚡ Integrating third-party services, including Google Cloud Platform (GCP)"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "nextjs",
      fontAwesomeClassname: "fab fa-next"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "National University Of Singapore (NUS)",
      logo: require("./assets/images/nusLogo2.jpg"),
      subHeader: "BEng in Systems Engineering, Minor Com Sci",
      duration: "June 2016 - June 2020",
      desc: "Grade: Honours with Distinction, 2nd Class Honours (Upper Division)",
      descBullets: [
        "Innovation and Design Centric Program (iDCP)",
        "NUS Overseas Colleges (Technopreneurship)"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "80%"
    },
    {
      Stack: "Databases",
      progressPercentage: "80%"
    },
    {
      Stack: "Software Architecture",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Aon",
      companylogo: require("./assets/images/aon.png"),
      date: "August 2021 – June 2022",
      descBullets: [
        "Full Stack development for tech platform for business owners to purchase business insurance.",
        "Frontend development using React, Redux and Apollo, building out UI interfaces based on Figma.",
        "Backend development using GraphQL and NodeJS in Typescript"
      ]
    },
    {
      role: "Software Engineer",
      company: "Hewlett Packard Enterprise (HPE)",
      companylogo: require("./assets/images/hpe.png"),
      date: "August 2020 – August 2021",
      descBullets: [
        "Full Stack Developer - Developed frontend UI interface in Typescript with React, Redux, Mobx.",
        "Developed multiple backend services in Typescript with Node.js, NestJS, TypeORM, Postgres.",
        "Provide support for microservices architecture using Redis, Azure EventHub, Docker and Kubernetes.",
        "Experienced with TDD, SCRUM methodology and developing features for Product Manager."
      ]
    },
    {
      role: "Software Engineer",
      company: "Thales",
      companylogo: require("./assets/images/thales.png"),
      date: "Jan 2020 – August 2020",
      descBullets: [
        "Mobile development in Swift and Android Studio",
        "Write unit, integration and e2e tests for mobile apps",
        "Build UI for mobile applications"
      ]
    },
    {
      role: "Software Engineer",
      company: "Orange Business Services",
      companylogo: require("./assets/images/obs.png"),
      date: "May 2018 – August 2018",
      descBullets: [
        "Build dashboard for IoT sensor Monitoring in ReactJS, NodeJS and PostgreSQL",
        "Build frontend UI for tracking and displaying user's emotions using ReactJS and open source ML Algorithms",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Freelance Contract Software Developer",
  subtitle: "Previous work as a Freelance Developer for Leading Startups and Organizations.",
  projects: [
    {
      image: require("./assets/images/exotic.png"),
      projectName: "Exotic Markets",
      projectDesc:
        "Exotic is transforming yield and options trading with transparent, on-chain, and fully collateralized structured products.",
      tech: "Typescript, ethersJS, web3JS, ReactJS, NextJS, Rust, F#",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://exotic.markets/"
        }
      ]
    },
    {
      image: require("./assets/images/upcover.png"),
      projectName: "Upcover",
      projectDesc:
        "Upcover is an insurance company (insurtech) plaform for small businesses.",
      tech: "Typescript, Redux, ReactJS, NextJS, NestJS, Nodejs",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.upcover.com/"
        }
      ]
    },
    {
      image: require("./assets/images/sherbet.png"),
      projectName: "Sherbet",
      projectDesc:
        "An NFT platform with an all-new cryptocurrency gambling experience.",
      tech: "Typescript, Redux, ReactJS, NextJS",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://sherbet.com/"
        }
      ]
    },
    {
      image: require("./assets/images/tipsiti.png"),
      projectName: "Tipsiti",
      projectDesc:
        "Tipsiti is a curated travel platform for spotlighting local places and products.",
      tech: "Typescript, Supabase, ReactJS, NextJS, Vercel",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.tipsiti.com/"
        }
      ]
    },
    {
      image: require("./assets/images/madpaws.png"),
      projectName: "Madpaws",
      projectDesc:
        "Mad Paws is an Australian-based pet services business whose primary activity is the operation of a pet care services online marketplace.",
      tech: "Typescript, Gatsby, Redux, ReactJS",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://petchemist.com.au/"
        }
      ]
    },
    {
      image: require("./assets/images/appvantage.png"),
      projectName: "Appvantage",
      projectDesc:
        "Appvantage empowers enterprises with AI-driven, mobile solutions that revolutionise application design and user experience.",
      tech: "Typescript, Redux, ReactJS, Nodejs, NestJS",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.appvantage.co/"
        }
      ]
    },
    {
      image: require("./assets/images/potraitAnalytics.png"),
      projectName: "Portrait Analytics",
      projectDesc:
        "Portrait Analytics is a personal research assistant that empowers analysts to discover and ramp up on new investment ideas in record time. Dive into your next great investment idea today",
      tech: "Typescript, NextJS, Redux, ReactJS",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://portrait-analytics.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/coinHall.png"),
      projectName: "Coinhall",
      projectDesc:
        "Coinhall provides realtime prices charts, analytics and swap aggregations across multiple chains",
      tech: "Typescript, NodeJS, MongoDB, PostgreSQL, ReactJS",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://coinhall.org/"
        }
      ]
    },
    {
      image: require("./assets/images/myco.png"),
      projectName: "Myco",
      projectDesc:
        "Myco makes it easy to earn money with friends by helping you assemble, collaborate, and launch social networks together.",
      tech: "Typescript, NodeJS, GraphQL, Apollo, ReactJS, Redux",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.myco.space/"
        }
      ]
    },
    {
      image: require("./assets/images/nftearth.png"),
      projectName: "NFTEarth",
      projectDesc:
        "NFT Marketplace built on L2 - Explore, Trade and Create NFTs on the Marketplace Built for L2.",
      tech: "Typescript, NodeJS, NextJS, GraphQL, ReactJS, Truffle, Ganache",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://nftearth.exchange/"
        }
      ]
    },
    {
      image: require("./assets/images/kinsta.png"),
      projectName: "Kinsta",
      projectDesc:
        "Kinsta is a Cloud Platform designed to help companies and dev teams ship and manage their web projects faster and more efficiently.",
      tech: "Typescript, ReactJS, Redux",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://kinsta.com/"
        }
      ]
    },
    {
      image: require("./assets/images/yale.png"),
      projectName: "Yale NUS",
      projectDesc:
        "Singapore's first liberal arts colleage with a full residential programme that integrates living and learning",
      tech: "Vue.js, Vuex, GraphQL, Hasura, PostgreSQL, Docker",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.yale-nus.edu.sg/"
        }
      ]
    },
    {
      image: require("./assets/images/carfix.png"),
      projectName: "Carfix SG",
      projectDesc:
        "Find the best car service, repair and upgrading deals. Compare quotes, book appointments, save time and money.",
      tech: "Typescript, Redux, ReactJS",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.carfixsg.co/"
        }
      ]
    },
    {
      image: require("./assets/images/yara.png"),
      projectName: "Yara Digital Farming",
      projectDesc:
        "Digitalizing agriculture worldwide",
      tech: "Google Dialogflow ,Redux, ReactJS",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.yara.com/digital-farming/"
        }
      ]
    },
    {
      image: require("./assets/images/boldy.png"),
      projectName: "Boldy",
      projectDesc:
        "Allows entrepreneurs to create their own ship in a few clicks with instant deployment. No commission on your turnover Your B2B customers will love it.",
      tech: "Typescript, TailwindCSS,  Redux, ReactJS",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.boldy.co/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Testimonials 🏆 "),
  subtitle: "Testimonials from former colleagues and bosses",

  achievementsCards: [
    {
      title: "Phil Douglas",
      subtitle:
        '"Shawn puts in a lot of effort and dedication into the project to deliver quality work, and is very professonal about his work."',
      image: require("./assets/images/phil.jpeg"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Madpaws",
          url: ""
        },
        {
          name: "Director of technology",
          url: ""
        }
      ]
    },
    {
      title: "Mirela Juravle",
      subtitle:
        '"Shawn is a very hardworking individual that loves taking on new challenges, he is an asset to any organization he joins."',
      image: require("./assets/images/mirela.jpeg"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Orange Business Services",
          url: ""
        },
        {
          name: "Head of Digital Solutions",
          url: ""
        }
      ]
    },
    {
      title: "Weston Nelson",
      subtitle:
        '"Shawn joined us as a frontend engineer. He works very quickly and is very accomodating, he is experienced and has definitely brought value to our team."',
      image: require("./assets/images/weston.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "NFTEarth",
          url: ""
        },
        {
          name: "Co-founder and smart contract developer",
          url: ""
        }
      ]
    },
    {
      title: "Connell Gough",
      subtitle:
        '"Shawn is a hardworker and very technical in terms of engineering practices and implementation, it was a pleasure working with him."',
      image: require("./assets/images/connell.jpeg"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Portrait Analytics",
          url: ""
        },
        {
          name: "Co-founder and Head of Engineering",
          url: ""
        }
      ]
    },
    {
      title: "Arya Soltanieh",
      subtitle:
        '"It was a pleasure to work with Shawn as he works really hard, and I hope to work with him again in the future."',
      image: require("./assets/images/arya.jpeg"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "Myco",
          url: ""
        },
        {
          name: "CTO",
          url: ""
        }
      ]
    },

    {
      title: "Mira Seo",
      subtitle:
        '"Shawn is very enthusiastic and collaborative and loves providing input from a technical and non-technical perspective to improve the application from a user perspective."',
      image: require("./assets/images/mira.jpg"),
      imageAlt: "PWA Logo",
      footerLink: [
        {
          name: "Yale - NUS",
          url: ""
        },
        {name: "Director, Common Curriculum", url: ""}
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Reach out! ☎️"),
  subtitle:
    "Let's work together, I am happy to work with you!",
  number: "+65-97244001",
  email_address: "slkq.dev@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
